import React from 'react'

export default function ProductsWithExpirationsFooterStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        .content-footer-container {
          display: flex;
          font-size: 1rem;
          padding: 5px;
          justify-content: flex-end;
        }
        .add-on-controls {
          font-size: 1.2em;
          display: flex;
          box-sizing: border-box;
          flex: 2;
        }
      `}
      </style>
    </React.Fragment>
  )
}
